import React from 'react';
import { Redirect } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import { get, compact } from 'lodash';
import { injectIntl } from 'react-intl';

import LoginForm from './LoginForm';
import {
  loginRequest,
  getExternalAuthMetadata
} from '~/redux/actions/authActions';
import { rootRoutes } from '~/common/routerConfig';

export const Login = ({
  intl,
  isLoading,
  isLoggedIn,
  error,
  loginRequest,
  getExternalAuthMetadata,
  location,
  logoutMessage
}) => {
  const handleLogin = ({ login, password }) => loginRequest(login, password);
  const { from } = location.state || { from: { pathname: rootRoutes.home } };
  const messageFromRoute = get(location, 'state.message');
  const messages = compact([messageFromRoute, logoutMessage]);

  if (isLoggedIn) {
    return <Redirect push to={from} data-testid="home-redirect" />;
  }

  return (
    <>
      <MetaTags>
        <title>{intl.formatMessage({ id: 'auth.login.title' })}</title>
      </MetaTags>

      <LoginForm
        isLoading={isLoading}
        onSubmit={handleLogin}
        error={error}
        messages={messages}
        intl={intl}
        getExternalAuthMetadata={getExternalAuthMetadata}
      />
    </>
  );
};

Login.propTypes = {
  isLoggedIn: PropTypes.bool,
  isLoading: PropTypes.bool,
  loginRequest: PropTypes.func,
  getExternalAuthMetadata: PropTypes.func,
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  location: PropTypes.object,
  logoutMessage: PropTypes.string,
  intl: PropTypes.any
};

const mapStateToProps = state => {
  return {
    isLoggedIn: state.auth.isLoggedIn,
    isLoading: state.progress.isLoading,
    error: state.auth.error,
    logoutMessage: state.auth.logoutMessage
  };
};

const mapDispatchToProps = {
  loginRequest,
  getExternalAuthMetadata
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Login));
